import { render, staticRenderFns } from "./ProductosLab.vue?vue&type=template&id=7ba8a83d&scoped=true"
import script from "./ProductosLab.vue?vue&type=script&lang=js"
export * from "./ProductosLab.vue?vue&type=script&lang=js"
import style0 from "./ProductosLab.vue?vue&type=style&index=0&id=7ba8a83d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8a83d",
  null
  
)

export default component.exports